import { useEffect } from 'react';
import { gsap } from 'gsap';
import './CursorBubble.css';

export default function CursorBubble() {
  useEffect(() => {
    const cursorBubble = document.querySelector('.cursor-bubble');
    if (!cursorBubble) return;

    const xTo = gsap.quickTo(cursorBubble, 'x', { duration: 0.5, ease: 'power3' });
    const yTo = gsap.quickTo(cursorBubble, 'y', { duration: 0.5, ease: 'power3' });

    let isHoveringClickable = false;
    let isHoveringDraggable = false;
    gsap.set(cursorBubble, { rotation: -30 });

    const onMouseMove = (e) => {
      xTo(e.clientX + 13);
      yTo(e.clientY - 43);
    };

    const onMouseOver = (e) => {
      // Clickable elements
      const clickableSelector = 'a, button, .v2-nav-item, .work-card, .glass-card, .hero-badge-tag, .tiktok-profile, .v2-btn, .testimonials-card';
      const clickableFound = e.target.closest(clickableSelector);

      // Draggable elements
      const draggableSelector = '.testimonials-cards-wrapper, .work-grid';
      const draggableFound = e.target.closest(draggableSelector);

      if (clickableFound && !isHoveringClickable) {
        isHoveringClickable = true;
        isHoveringDraggable = false;
        cursorBubble.textContent = 'click';
        gsap.killTweensOf(cursorBubble, 'opacity,scale,rotation');
        gsap.to(cursorBubble, { opacity: 1, scale: 1, rotation: 0, duration: 1.7, delay: 0.1, ease: 'elastic.out(1, 0.4)' });
      } else if (draggableFound && !isHoveringDraggable && !clickableFound) {
        isHoveringDraggable = true;
        isHoveringClickable = false;
        cursorBubble.textContent = 'drag';
        gsap.killTweensOf(cursorBubble, 'opacity,scale,rotation');
        gsap.to(cursorBubble, { opacity: 1, scale: 1, rotation: 0, duration: 1.7, delay: 0.1, ease: 'elastic.out(1, 0.4)' });
      } else if (!clickableFound && !draggableFound && (isHoveringClickable || isHoveringDraggable)) {
        isHoveringClickable = false;
        isHoveringDraggable = false;
        gsap.killTweensOf(cursorBubble, 'opacity,scale,rotation');
        gsap.to(cursorBubble, { opacity: 1, scale: 0, rotation: -30, duration: 0.3, ease: 'sine.inOut' });
      }
    };

    const onMouseLeave = () => {
      if (isHoveringClickable || isHoveringDraggable) {
        isHoveringClickable = false;
        isHoveringDraggable = false;
        gsap.killTweensOf(cursorBubble, 'opacity,scale,rotation');
        gsap.to(cursorBubble, { opacity: 1, scale: 0, rotation: -30, duration: 0.3, ease: 'sine.inOut' });
      }
    };

    window.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseover', onMouseOver);
    document.addEventListener('mouseleave', onMouseLeave);

    return () => {
      window.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseover', onMouseOver);
      document.removeEventListener('mouseleave', onMouseLeave);
    };
  }, []);

  return <div className="cursor-bubble">click</div>;
}
